import { LOCAL_STORAGE_PREFIX } from 'const';

export function HandleLastBetParams() {
  const queryParams = new URLSearchParams(window.location.search);
  const saveLastBet_param = queryParams.get('saveLastBet');
  const saveLastBet_LC = localStorage.getItem(LOCAL_STORAGE_PREFIX + 'saveLastBet');

  if (!saveLastBet_param) {
    return; // do nothing
  } else if (saveLastBet_param == 'false' || saveLastBet_param == 'disable' || saveLastBet_param == 'disabled') {
    if (saveLastBet_LC == 'false')
      return;
    localStorage.setItem(LOCAL_STORAGE_PREFIX + 'saveLastBet', false);
    alert('Disabled saving of last bets');
    console.log('Saving of last bets disabled');

  } else {
    if (saveLastBet_LC != 'false')
      return;
    localStorage.setItem(LOCAL_STORAGE_PREFIX + 'saveLastBet', true);
    alert('Your last bet will now be saved and suggested when making a new bet');
    console.log('Saving of last bets enabled');
  }
}
